<template>
    <div class="funnels">
        <OnboardHint name="funnels" v-if="isOnboarding" :app="app">
            <template slot="content">
                <h4><i>🙀</i> What exactly is a... <em>Funnel</em>?</h4>
                <p>A "Funnel" is a sequence of emails. This could be anything from a single Newsletter to a 7-part Mini-Course.</p>
                <p>Click on the <strong>Welcome</strong> funnel below to see the "steps" it contains.</p>
                <p>When you're done, head over to the <router-link to="/settings/attributes">Settings</router-link> page for more tips.</p>
            </template>
            <template slot="button">
                Thanks! <span class="hint inline">and hide this message</span>
            </template>
        </OnboardHint>

        <OnboardHint name="upgrade-funnels" v-else-if="showLimitHint" :app="app">
            <template slot="content">
                <h4><i>😬</i> You've run out of free funnels!</h4>
                <p>The free version of this plug-in only includes 1 funnel... but more funnels are within your grasp!</p>
                <a href="https://www.drip-funnels.com/try/" target="_blank" class="button">
                    Try Unlimited FREE for 14 Days
                </a> &nbsp;
                <a href="javascript:;" @click="app.showActivationModal" class="link">Enter Activation Code</a>
            </template>
        </OnboardHint>

        <div class="meta-nav">
            <input type="text" v-model="q" placeholder="Search..." class="search">

            <ul>
                <li :class="showLimitHint ? 'disabled-nevermind' : ''">
                    <a @click="showLimitHint ? app.showActivationModal('Add More Funnels') : app.showAddFunnelModal()" href="javascript:;">
                        + Add Funnel
                    </a>
                </li>
            </ul>
        </div>

        <div class="table-wrapper">
            <table class="table with-hover">
                <thead>
                    <tr>
                        <th><a>ID</a></th>
                        <th><a>Name</a></th>
                        <th><a>Steps</a></th>
                        <!-- <th><a>People</a></th> -->
                        <th class="no-padding has-checkbox"></th>
                        <th class="no-padding has-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!funnels.length">
                        <td colspan="5" class="align-center">
                            <a>Click "+ Add Funnel" to add your first funnel!</a>
                        </td>
                    </tr>

                    <template v-else>
                        <tr v-for="funnel in funnels" :key="'funnel-' + funnel.id">
                            <td class="narrow align-center">
                                <a>{{funnel.id}}</a>
                            </td>
                            <td>
                                <router-link :to="`/funnels/${funnel.id}`" class="link">
                                    {{funnel.name}}
                                </router-link>
                            </td>
                            <td><a>{{funnel.steps ? funnel.steps.length : 0}} Steps</a></td>
                            <!-- <td><a>{{app.people.length}} People</a></td> -->
                            <td class="has-checkbox align-center">
                                <a v-on:click="duplicate(funnel)" href="javascript:;">
                                    <font-awesome-icon icon="copy" />
                                </a>
                            </td>
                            <td class="has-checkbox align-center">
                                <a v-on:click="remove(funnel)" href="javascript:;">
                                    <font-awesome-icon icon="trash" />
                                </a>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import OnboardHint from '@/pods/onboard-hint/component.vue';

export default {
    props: ['app'],
    components: {
        OnboardHint
    },
    data() {
        return {
            funnelLimit: 1,
            q: ''
        };
    },
    computed: {
        funnels() {
            var _ = this,
                q = _.q.toLowerCase(),
                funnels = _.app.funnels;

            if (q) {
                funnels = funnels.filter(function(funnel) {
                    return funnel.name.toLowerCase().indexOf(q) !== -1;
                });
            }

            return funnels.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        isOnboarding() {
            var _ = this;

            return !_.app.subscription && !_.app.funnels.filter(function(funnel) {
                return funnel.name !== 'Welcome';
            }).length;
        },
        atFunnelLimit() {
            var _ = this;
            return _.app.funnels.length >= _.funnelLimit;
        },
        showLimitHint() {
            var _ = this;
            return _.atFunnelLimit && !_.app.subscription;
        }
    },
    methods: {
        remove(funnel) {
            var _ = this;

            if (confirm('Are you sure you want to delete this funnel?')) {
                _.app.funnels.splice(_.app.funnels.indexOf(funnel), 1);

                _.app.requester.request({
                    controller: 'funnels',
                    action: 'delete',
                    id: funnel.id
                });
            }
        },

        duplicate(funnel) {
            var _ = this;

            if (confirm('Are you sure you want to duplicate this funnel?')) {
                var clone = JSON.parse(JSON.stringify(funnel));

                delete clone.id;

                clone.name += ' (Copy)';

                _.app.requester.request({
                    controller: 'funnels',
                    action: 'save',
                    funnel: clone
                }, function(err, data) {
                    _.app.$router.push(`/funnels/${data.funnels[0].id}`);
                });
            }
        }
    }
};
</script>
